export default __webpack_public_path__ + "static/media/benefit_7.31f16032.png";